import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { toast } from "sonner";

export const exportToExcel = async (
  granted,
  registeredGames,
  totalTrafic,
  quarterlyRevenue,
  pastWeekDonations,
  toppersReportData,
  adViewCompletionData,
  adViewPerGameData
) => {
  if (!granted?.some((g) => g.type === "download-excel")) {
    toast.error("You don't have neccessary permissions to do this operation!", {
      duration: 3000,
    });
    return;
  }
  await exportGamesCountToExcel(registeredGames);
  await userTrafficToExcel(totalTrafic);
  await quarterlyRevenueToExcel(quarterlyRevenue);
  await donationsToExcel(pastWeekDonations);
  await toppersReportToExcel(toppersReportData);
  await exportAdsCompletionRateData(adViewCompletionData);
  await exportAdsCountsPerMonth(adViewPerGameData)
};

export const exportGamesCountToExcel = async (registeredGames) => {
  try {
    if (registeredGames?.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Games Count");

      worksheet.columns = [
        { header: "Game Type", key: "gameType", width: 30 },
        { header: "Total Games", key: "totalGames", width: 15 },
        { header: "Percentage", key: "percentage", width: 15 },
      ];
      const totalCount = registeredGames.reduce(
        (sum, game) => sum + game.count,
        0
      );

      registeredGames.forEach((item) => {
        worksheet.addRow({
          gameType: item.category,
          totalGames: item.count,
          percentage: `${Math.floor((item.count / totalCount) * 100)}%`,
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "games.xlsx");
      toast.success("Games count been created and downloaded.", {
        duration: 2000,
      });
    }
  } catch (error) {
    console.error("Error exporting data to Excel:", error);
  }
};

export const userTrafficToExcel = async (totalTrafic) => {
  try {
    if (totalTrafic?.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("User Traffic");

      worksheet.columns = [
        { header: "Year", key: "year", width: 15 },
        { header: "Quarter", key: "quarter", width: 15 },
        { header: "Countries", key: "Countries", width: 15 },
        { header: "Provinces", key: "Provinces", width: 15 },
        { header: "Cities", key: "Cities", width: 15 },
      ];

      totalTrafic.forEach((item) => {
        worksheet.addRow({
          year: item.year,
          quarter: item.quarter,
          Countries: item.distinctCountries,
          Provinces: item.distinctProvinces,
          Cities: item.distinctCities,
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "user-traffic.xlsx");
      toast.success("User Traffic File has been created and downloaded.", {
        duration: 2000,
      });
    }
  } catch (error) {
    console.error("Error exporting data to Excel:", error);
  }
};

export const quarterlyRevenueToExcel = async (quarterlyRevenue) => {
  try {
    if (quarterlyRevenue?.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("User Traffic");

      worksheet.columns = [
        { header: "Date", key: "date", width: 15 },
        { header: "Countries", key: "countries", width: 15 },
        { header: "Provinces", key: "provinces", width: 15 },
        { header: "Cities", key: "cities", width: 15 },
      ];

      quarterlyRevenue.forEach((item) => {
        worksheet.addRow({
          date: item.date,
          cities: item.cities,
          countries: item.countries,
          provinces: item.provinces,
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "revenue.xlsx");
      toast.success("Revenue File has been created and downloaded.", {
        duration: 2000,
      });
    }
  } catch (error) {
    console.error("Error exporting data to Excel:", error);
  }
};

export const donationsToExcel = async (pastWeekDonations) => {
  try {
    if (pastWeekDonations?.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("User Traffic");

      worksheet.columns = [
        { header: "Date", key: "date", width: 15 },
        { header: "Countries", key: "countries", width: 15 },
        { header: "Provinces", key: "provinces", width: 15 },
        { header: "Cities", key: "cities", width: 15 },
      ];

      pastWeekDonations.forEach((item) => {
        worksheet.addRow({
          date: item.date,
          countries: item.cities,
          provinces: item.countries,
          cities: item.provinces,
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "donations.xlsx");
      toast.success("Donations File has been created and downloaded.", {
        duration: 2000,
      });
    }
  } catch (error) {
    console.error("Error exporting data to Excel:", error);
  }
};

export const toppersReportToExcel = async (toppersReportData) => {
  try {
    if (toppersReportData?.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Toppers Report");

      worksheet.columns = [
        { header: "Country Name", key: "name", width: 15 },
        { header: "Country Code", key: "country", width: 15 },
        { header: "Users", key: "value", width: 15 },
      ];

      toppersReportData.forEach((item) => {
        worksheet.addRow({
          name: item.name,
          country: item.country,
          value: item.value,
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "users-globaly.xlsx");
      toast.success("Users-Globaly File has been created and downloaded.", {
        duration: 2000,
      });
    }
  } catch (error) {
    console.error("Error exporting data to Excel:", error);
  }
};

export const exportAdsCompletionRateData = async (adViewCompletionData) => {
  try {
    if (adViewCompletionData?.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Total Ads Per Game");

      worksheet.columns = [
        { header: "Game", key: "game", width: 15 },
        { header: "Total Ads", key: "totalAds", width: 15 },
        { header: "Completely Watched", key: "completelywatched", width: 25 },
        { header: "Skipped", key: "skipped", width: 15 },
        { header: "Percentage", key: "percentage", width: 15 },
      ];

      adViewCompletionData.forEach((item) => {
        worksheet.addRow({
          game: item.game_title,
          totalAds: item.total_ads,
          completelywatched: item.watched_ads,
          skipped: item.skiped_ads,
          percentage: `${((item.watched_ads / item.total_ads) * 100).toFixed(1)}%`,
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Total-Ads-Per-Game.xlsx");
      toast.success(
        "Total Ads Per Game File has been created and downloaded.",
        {
          duration: 2000,
        }
      );
    }
  } catch (error) {
    console.error("Error exporting data to Excel:", error);
  }
};

export const exportAdsCountsPerMonth = async (adViewPerGameData) => {
  try {
    if (adViewPerGameData?.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Ads Counts Per Month By Games");

      const cols = [{ header: "Game", key: "game", width: 20 }];

      const months = adViewPerGameData[0]?.data?.map((item) => item.date) || [];

      months.forEach((month) => {
        cols.push({
          header: month,
          key: month.replace(/-/g, "_"),
          width: 15,
        });
      });

      worksheet.columns = cols;
      console.log("Columns :", cols);

      adViewPerGameData.forEach((game) => {
        const row = { game: game.title };

        months.forEach((month) => {
          const monthData = game.data.find((d) => d.date === month);
          row[month.replace(/-/g, "_")] = monthData ? monthData.total_ads : 0;
        });

        worksheet.addRow(row);
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Ads-Counts-Per-Month-By-Games.xlsx");

      toast.success("Ads Counts Per Month By Games File has been created and downloaded.", {
        duration: 2000,
      });
    }
  } catch (error) {
    console.error("Error exporting data to Excel:", error);
  }
};
